import React, { useEffect } from 'react';
import Header from '../components/Header';

const valores = [
  {
    img: 'images/logoMision.png',
    title: 'Misión',
    text: 'Otorgar un servicio educativo no formal, innovador, interactivo y divertido sobre el conocimiento cultural, artístico y tecnológico.',
  },
  {
    img: 'images/logoVision.png',
    title: 'Visión',
    text: 'Consolidarse como un apoyo educativo, un centro de recreación y convivencia familiar donde se divulgue la ciencia, el arte y la tecnología.',
  },
  {
    img: 'images/logoObjetivo.png',
    title: 'Objetivo',
    text: 'Promover, difundir y divulgar la ciencia, el arte y la tecnología, en forma novedosa, atractiva, interactiva y divertida.',
  },
];

const Quienes = () => {
  useEffect(() => {
    if (window.startx) {
      window.startx();
    }
  }, []);

  return (
    <main id="main" className="wrapper style1">

      {/* ===== CONTENIDO PRINCIPAL ===== */}
      <div className="container">

        <header className="major text-center">
          <h2>¿Quiénes Somos?</h2>
        </header>

        <img
          className="imagenAvion img-fluid mb-4"
          src="images/avion.jpg"
          alt="Vista aérea del Museo Interactivo El Rehilete"
        />

        <section className="textoJ">
          <Header />

          <article className="grid-item1">
            <p>
              El Museo Interactivo para la Niñez y la Juventud Hidalguense
              “El Rehilete” abrió sus puertas al público el 28 de febrero de 1997,
              como resultado de un proyecto desarrollado por el Gobierno del
              Estado de Hidalgo. Desde entonces, ha recibido visitantes de los
              84 municipios del estado, de entidades circunvecinas e incluso de
              otros países.
            </p>

            <p>
              El museo recibe el nombre de “El Rehilete” por el juguete
              tradicional mexicano y porque, desde el punto de vista
              tecnológico, representa la transformación de la energía. Además,
              Pachuca es conocida como “La Bella Airosa”, lo que refuerza la
              identidad del museo como un espacio lúdico y científico.
            </p>

            <p>
              El edificio fue diseñado específicamente para funcionar como un
              museo interactivo. Su forma poligonal de 24 caras y sus cuatro
              niveles, conectados por rampas, están inspirados en la tradición
              minera de la región, permitiendo que el visitante ascienda por
              niveles simulando el recorrido de una mina.
            </p>
          </article>
        </section>
      </div>

      {/* ===== MISIÓN / VISIÓN / OBJETIVO ===== */}
      <section className="objetivos textoJ mt-5">
        <div className="container">
          <div className="row">

            {valores.map((item, index) => (
              <div
                key={index}
                className="col-md-4 col-sm-12 col-12 text-center mb-4"
              >
                <img
                  className="iconoCentro mb-3"
                  src={item.img}
                  alt={item.title}
                />
                <h3>{item.title}</h3>
                <p>{item.text}</p>
              </div>
            ))}

          </div>
        </div>
      </section>

    </main>
  );
};

export default Quienes;